import {
  getParamByIdsOptions,
  getParamByIdsQueryKey,
} from '@/client/@tanstack/react-query.gen'
import { readCache } from '@/store/action'

const keys = [
  'rule',
  'errors',
  'missionResetCoin',
  'gameInstantPlay',
  'prizeImage',
  'game-1-video',
  'game-2-video',
  'game-3-video',
  'game-1-rule',
  'game-2-rule',
  'game-3-rule',
  'time_game_3',
  'time_game_2',
  'time_game_1',
  'gift_config_game_2',
  'tank_score',
  'heli_score',
  'config_banner',
  'config_bg_banner',
  'share_content',
  'link_sound_mv',
  'link_ytb',
  'time_update',
] as const

type ParamKey = (typeof keys)[number]
type Params = Record<ParamKey, any>

//Params
export const getParams = () => {
  return readCache<any, Params>(
    getParamByIdsQueryKey({
      path: {
        ids: keys as any,
      },
    }),
  )
}
export const useParamsOptions = () => {
  return getParamByIdsOptions({
    path: {
      ids: keys as any,
    },
  })
}
